var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { ofType } from "redux-observable";
import { from, of } from "rxjs";
import { catchError, switchMap } from "rxjs/operators";
import { selectExperienceProductionBuffAmount, selectProductionResourceTotalBuffAmount, } from "../../../../selectors/selectBuffsInfo";
import { selectBuildingInfoById } from "../../../../selectors/selectExistingBuildingInfo";
import { selectBuffFactorAddition } from "../../../../selectors/selectProduction";
import { CommandCode, } from "../../../../utils/network/generated/protoTypes";
import { shallowDiffers } from "../../../../utils/shallowDiffers";
import { utilBuildings } from "../../../../utils/utilBuildings";
import { actionAddPelletsAnimations } from "../../../animation/actionPelletAnimations";
import { getResourceIconInfo } from "../../../generic/icon/getResourceIconInfo";
import { IdIcon } from "../../../generic/icon/IdIcon";
import { actionProductionCollect, actionProductionReAdd, TypeActionProductionInfo, } from "../actionProductionInfo";
export var epicProductionCanCollectProducts = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionProductionInfo.PreCollect), switchMap(function (action) {
        var state = state$.value;
        var buildingFromAction = action.building;
        return deps
            .netSend({
            id: CommandCode.CollectProducts,
            props: {
                buildingId: buildingFromAction.proto.id,
                farmId: state.playerBase.base.baseId,
                playerId: state.playerInfo.playerId,
            },
        })
            .pipe(switchMap(function (res) {
            // get events resources pellets / buffed resources pellets / to show with running animation
            // TODO: remove this logic and replace proper logic to calculate production items keeping in mind buffs
            // refresh building because it might be outdated when coming from another action
            var building = selectBuildingInfoById(state, buildingFromAction.proto.id);
            var buffedProducts = getBuffedProducts(state, action.products.product, action.building);
            var rewardPellets = [];
            if (shallowDiffers(res.product, buffedProducts)) {
                var extraProducts_1 = [];
                res.product.forEach(function (product) {
                    var current = buffedProducts.find(function (p) { return p.typeId === product.typeId; });
                    if (current && !current.amount.equals(product.amount)) {
                        var diff = product.amount.subtract(current.amount);
                        var amount = diff.isNegative() ? diff.negate() : diff;
                        extraProducts_1.push(__assign({}, current, { amount: amount }));
                    }
                    else if (!current) {
                        extraProducts_1.push(product);
                    }
                });
                rewardPellets = extraProducts_1.map(function (resource) {
                    return getResourceIconInfo(resource);
                });
            }
            if (!res.xp.equals(getBuffedXp(state, action.products.xp))) {
                var diff = res.xp.subtract(action.products.xp);
                var extraXp = diff.isNegative() ? diff.negate() : diff;
                rewardPellets.push({
                    amount: extraXp,
                    icon: IdIcon.XpIcn,
                });
            }
            if (rewardPellets.length > 0) {
                var origin = utilBuildings.getCenterPositionMinSquareGlobal(building);
                return from([
                    actionAddPelletsAnimations(building.proto.id, rewardPellets, origin),
                    actionProductionCollect(building, res),
                ]);
            }
            return of(actionProductionCollect(building, res));
        }), catchError(function () { return of(actionProductionReAdd(buildingFromAction.proto.id)); }));
    }));
};
var getBuffedProducts = function (state, products, building) {
    var multiplier = selectBuffFactorAddition(state, building);
    return products.map(function (resource) {
        var buffedAmount = selectProductionResourceTotalBuffAmount(state, resource.typeId, resource.amount, multiplier);
        return __assign({}, resource, { amount: buffedAmount.add(resource.amount) });
    });
};
var getBuffedXp = function (state, xp) {
    return xp.add(selectExperienceProductionBuffAmount(state, xp));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/info/production/epics/epicProductionCanCollectProducts.ts
// module id = 1936
// module chunks = 3